import { useState, FC } from "react";
import { UserPasswordsBody } from "@vviinn/user-managment-client-ts";

import { Pencil } from "lucide-react";
import { PasswordInput } from "../components/Interaction/PasswordInput";

import { AcceptableNamedRow } from "../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import {
  SLIDEOVER_EDIT_ICON_ICON_STYLES,
  SLIDEOVER_EDIT_ICON_WRAPPER_STYLES,
} from "../ui/layout/organisms/SlideOver/styles";
import { TypedPromiseWithTwoProps } from "../helpers/functions/types";

export const ChangePasswordAcceptableRow: FC<{
  userId: string;
  handleChangePassword: TypedPromiseWithTwoProps<string, UserPasswordsBody>;
}> = ({ userId, handleChangePassword }) => {
  const [newPassword, setNewPassword] = useState("");

  const clearFields = () => {
    setNewPassword("");
  };

  const changePassword = async () =>
    await handleChangePassword(userId, { oldPassword: "", newPassword });

  return (
    <AcceptableNamedRow
      title="Password"
      permissionsGroup="user:user"
      content="**********"
      onSubmit={changePassword}
      initConfig={clearFields}
      allowSubmit={newPassword.length > 7}
    >
      <div className={SLIDEOVER_EDIT_ICON_WRAPPER_STYLES}>
        <Pencil className={SLIDEOVER_EDIT_ICON_ICON_STYLES} />
      </div>
      <PasswordInput
        value={newPassword}
        id="new-password"
        placeholder="New password"
        onChange={(e) => {
          setNewPassword(e.target.value);
        }}
        required={true}
      />
    </AcceptableNamedRow>
  );
};
